import { general } from './general';

export const employmentactivity = (data = {}) => general('employmentactivity', (data || {}));
